export const useBeforeunloadBlock = () => {
  const isBlocked = ref<boolean>(true)

  function checkWindow(event: BeforeUnloadEvent) {
    if (isBlocked.value) {
      event.preventDefault();
      event.returnValue = '編集中のものは保存されませんが、よろしいですか？'
    }
  }

  useEventListener(window, 'beforeunload', checkWindow)

  return { isBlocked }
}
